var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mx-2",class:_vm.gradient ? '' : 'mb-4'},[_c('div',{class:_vm.gradient ? 'text-gradient-primary font-globo' : 'font-globo',style:({
      fontSize: _vm.gradient
        ? 'clamp(20px, 4vw, 32px)'
        : 'clamp(24px, 5vw, 38px)',
    })},[_vm._v(" "+_vm._s(_vm.pageLabel)+" ")]),_c('Breadcrumb')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }